import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2l0 -12","key":"svg-0"}],["path",{"d":"M10 8v8","key":"svg-1"}],["path",{"d":"M14 8v8","key":"svg-2"}],["path",{"d":"M8 10h8","key":"svg-3"}],["path",{"d":"M8 14h8","key":"svg-4"}]]

const IconGridPattern = createReactComponent('outline', 'grid-pattern', 'GridPattern', __iconNode);

export default IconGridPattern;